<template lang="html">
  <v-dialog
    v-model="show"
    :width="width"
    persistent>
    <template #activator="{ on }">
      <slot name='activator' v-bind:on='on'>
        <v-btn v-on='on' dark>Activate Dialog</v-btn>
      </slot>
    </template>
    <v-card
      :color="color"
      dark
      class="text-xs-center">
      <v-card-title class='headline'> {{title}} </v-card-title>
      <v-card-text>
        <slot name="main">
          <p>Hello, I am a Dialog. Looks like someone forgot to give me content</p>
        </slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <slot name="actions" :deactivate='listeners'>
          <v-btn
            color="success"
            @click="show = false">
            Close
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    width: { required: false, type: Number, default: 500 },
    color: { required: false, default: 'secondary', type: String },
    title: { required: false, default: 'Complete Action', type: String}
  },
  computed: {
    listeners () {
      return {
        click: e => {
          e.stopPropagation();
          this.show = false;
        }
      }
    }
  },
  data: () => {
    return {
      show: false,
    }
  },
}
</script>

<style lang="css" scoped>
</style>
